import { useState, useEffect } from 'react';
import { fetchUserAttributes } from 'aws-amplify/auth';

interface UserAttributes {
  email?: string;
  name?: string;
  'custom:role'?: string;
  'custom:tenantId'?: string;
}

export const useUserAttributes = () => {
  const [attributes, setAttributes] = useState<UserAttributes | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getUserAttributes = async () => {
      try {
        const userAttributes = await fetchUserAttributes();
        console.log('Fetched user attributes:', userAttributes);
        setAttributes(userAttributes);
      } catch (err) {
        console.error('Error fetching user attributes:', err);
        setError('Failed to fetch user attributes');
      } finally {
        setLoading(false);
      }
    };

    getUserAttributes();
  }, []);

  return { attributes, loading, error };
};